import { render, staticRenderFns } from "./LibraryContentPanel.vue?vue&type=template&id=6dcdd6e8&scoped=true"
import script from "./LibraryContentPanel.vue?vue&type=script&lang=js"
export * from "./LibraryContentPanel.vue?vue&type=script&lang=js"
import style0 from "./LibraryContentPanel.vue?vue&type=style&index=0&id=6dcdd6e8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dcdd6e8",
  null
  
)

export default component.exports